export default __webpack_public_path__ + "fonts/open-sans-v16-latin-600.woff";